export const OPTIONAL_PROPERTIES = [
	"labels",
	"cycle",
	"estimate",
	"dueDate",
	"parent",
] as const

export type OptionalProperty = (typeof OPTIONAL_PROPERTIES)[number]

type PropertyFlags = Record<OptionalProperty, boolean>

// Linear's layout: a set property stays in the row, an empty one waits behind "…"
// until someone picks it there.
export function splitOptionalProperties({
	available,
	isSet,
	revealed,
}: {
	available: PropertyFlags
	isSet: PropertyFlags
	revealed: ReadonlySet<OptionalProperty>
}) {
	const shown: OptionalProperty[] = []
	const hidden: OptionalProperty[] = []
	for (const property of OPTIONAL_PROPERTIES) {
		if (isSet[property] || (available[property] && revealed.has(property))) {
			shown.push(property)
		} else if (available[property]) {
			hidden.push(property)
		}
	}
	return { shown, hidden }
}
